{
	"title": "Adjust carbon balance",
	"description": "Please enter the amount of carbon reductions to be deducted from the buffer to adjust the carbon bank balance and provide a comment explaining the reason for the adjustment.",
	"transactionId": "Transaction ID",
	"fossilAmountLabel": "Enter a fossil amount (kg CO2)",
	"remainingFossilBuffer": "Remaining fossil buffer",
	"biogenicAmountLabel": "Enter a biogenic amount (kg CO2)",
	"remainingBiogenicBuffer": "Remaining biogenic buffer",
	"reasonLabel": "Enter a reason",
	"reasonHint": "Please describe the reason for the adjustment.",
	"warning": "During the annual assurance process, the assurance body will review all balance adjustments. Prior to making any adjustments, it is mandatory to contact the assurance body to discuss the proposed changes.",
	"closeWarning": "Close warning",
	"approvalLabel": "I hereby confirm that this adjustment has been approved by the assurance body.",
	"cancel": "Cancel",
	"adjustBalance": "Adjust balance",
	"adjustSuccess": "Balance adjustment added to the Carbon Bank.",
	"adjustError": "Failed to adjust the carbon balance. Please try again."
}
